// 手机号中间4位脱敏展示
const encryptPhone = phone => phone && phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
// 身份证号中间10位脱敏展示
const encryptID = id => id && id.replace(/(\d{4})\d{10}(\w{4})/, '$1*****$2');

export default { encryptPhone, encryptID };
